import { Component, OnInit } from '@angular/core';
import { HeaderType } from 'src/app/dataModels/header-type';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';

/**
 * Dialog component
 */
@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  /**
   * Title of the modal dialog
   */
  title: string;

  /**
   * message to be displayed on the modal dialog
   */
  message: any;

  /**
   * list of buttons to be displayed on the modal
   */
  btnOptions: any[] = [];

  /**
   * value of the button label
   */
  value: string;

  /**
   * Header type
   */
  type: HeaderType;

  /**
   * subscription for the dialog service to call instead of onHidden
   */
  public onHide: Subject<string> = new Subject();

  /**
   * constructor to inject dependency
   * @param dialogRef instance of ngxBsModalRef
   * @param sanitizer instance of DOM Sanitizer
   */
  constructor(public dialogRef: BsModalRef, private sanitizer: DomSanitizer) {}

  /**
   * initialize component
   */
  ngOnInit() {
    this.message = this.sanitizer.bypassSecurityTrustHtml(this.message);
  }

  /**
   * close the modal
   * @param value contains label of the button clicked by the user
   */
  closeModal(value) {
    this.onHide.next(value);
    this.dialogRef.hide();
  }
}
